import { Moment } from 'moment'

export enum OrderPaymentType {
  CreditCard = 'CreditCard',
  All = 'All',
}

export type OrderPaymentRequest = {
  type: OrderPaymentType,
  minDate: Moment,
  maxDate: Moment,
}

export type OrderPaymentVariables = {
  type: OrderPaymentType,
  minDate: string,
  maxDate: string,
}

export type OrderMailingLabel = {
  templateName: 'Mailing',
  variables: Record<string, string>,
}

export type purchaseOrderBackOrderDeliverables = {
  id: number,
  orderId: number,
  contactId: string,
  name: string,
  sku: string,
  description: string,
  purchaseOrderNumber: number,
  email: string,
  phone: string,
  emailSent: boolean,
}
